import api from '@/api'

export default {
  addScanTool({ commit, state }, data) {
    commit('ADD_SCANTOOL', data)
  },
  setScanTool({ commit, state }, data) {
    commit('SET_SCANTOOL', data)
  },
  cancelNewScanTool({ commit }) {
    commit('CANCEL_NEWSCANTOOL')
  },
  addReportTemplate({ commit, state }, data) {
    commit('ADD_REPORT_TEMPLATE', data)
  },
  setReportTemplate({ commit, state }, data) {
    commit('SET_REPORT_TEMPLATE', data)
  },
  cancelNewReportTemplate({ commit }) {
    commit('CANCEL_NEWREPORTTEMPLATE')
  },
  async getScanTools({ commit }) {
    return new Promise((resolve, reject) => {
      api.getScanTools()
        .then(response => {
          commit('SET_SCANTOOLS', response.data)
          resolve(response)
        })
    })
  },
  async saveScanTool({ commit, state }) {
    state.scantools.forEach(scantool => {
      if (scantool.isChanged) {
        return new Promise((resolve, reject) => {
          api.saveScanTool(scantool, { headers: { 'content-type': 'application/json' } })
            .then(response => {
              commit('SET_SCANTOOL', {
                id: 0,
                name: 'id',
                value: response.data
              })
              scantool.isChanged = false
              resolve(response)
            })
        })
      }
    })
  },
  async removeScanTool({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.removeScanTool(id)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getReportTemplates({ commit }, area) {
    return new Promise((resolve, reject) => {
      api.getReportTemplates(area)
        .then(response => {
          commit('SET_REPORT_TEMPLATES', response.data)
          resolve(response)
        })
    })
  },
  async saveReportTemplate({ commit, state }, data) {
    state.reportTemplates.forEach(reportTemplate => {
      if (reportTemplate.isChanged) {
        console.log('Saving Report Template', reportTemplate)
        return new Promise((resolve, reject) => {
          api.saveReportTemplate(reportTemplate, { headers: { 'content-type': 'application/json' } })
            .then(response => {
              console.log('Saved Report Template', response.data)
              commit('SET_REPORT_TEMPLATE', {
                id: 0,
                name: 'id',
                value: response.data
              })
              reportTemplate.isChanged = false
              resolve(response)
            })
        })
      }
    })
  },
  async removeReportTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.removeReportTemplate(id)
        .then(response => {
          resolve(response)
        })
    })
  },
  saveTechInfo({commit}, tech) {
    commit('SAVE_TECH_INFO', tech)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report/actions.js